import { useDispatch } from "react-redux";
import { updateCartLineItem } from "store/vino/cartSlice";

const QuantityInput = ({ cartLineItem }) => {
	const dispatch = useDispatch();

	const handleAddQty = () => {
		const lineItem = {
			id: cartLineItem.id,
			variantId: cartLineItem.variantId,
			quantity: cartLineItem.quantity + 1,
		};
		dispatch(updateCartLineItem(lineItem));
	};

	const handleRemoveQty = () => {
		const lineItem = {
			id: cartLineItem.id,
			variantId: cartLineItem.variantId,
			quantity: cartLineItem.quantity - 1,
		};
		dispatch(updateCartLineItem(lineItem));
	};

	return (
		<button className="btn btn-outline-primary action-btn">
			<div className="add-prod flex w-full justify-between">
				<span className="ad-sign decrease">
					<i
						className="cursor-pointer inline-block align-middle fa-solid fa-angle-left fa-lg"
						onClick={handleRemoveQty}
					/>
				</span>
				<span className="prod-total">{cartLineItem?.quantity}</span>
				<span className="ad-sign increase">
					<i
						className="cursor-pointer inline-block align-middle fa-solid fa-angle-right fa-lg"
						onClick={handleAddQty}
					/>
				</span>
			</div>
		</button>
	);
};

export default QuantityInput;
